import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import useAuthBridge from "../hooks/useAuthBridge";
import useHideChannelTalk from "../hooks/useHideChannelTalk";
/**
 * solvookApp 전용 레이아웃 래퍼
 * - 모든 solvookApp 페이지에서 공통으로 필요한 브릿지 훅을 한 곳에서 관리
 * - Layout 레벨에서 마운트되므로 페이지 전환 시에도 이벤트 리스너가 유지됨
 */ const SolvookAppLayout = (param)=>{
    let { children  } = param;
    useAuthBridge();
    useHideChannelTalk();
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
export default SolvookAppLayout;
